export const MentionsContextKey = Symbol('MentionsContextKey');

export const MentionsopenDialogValue = Symbol('MentionsopenDialogValue');
